<script>
// Bloco "Em breve" estilizado com a cor da marca
export default {
  locales: {
    pt: {
      'Coming soon': 'Em breve',
      'Something new is on the way': 'Algo novo está a caminho',
      'We are preparing something new for you. Stay tuned!': 'Estamos preparando algo novo para você. Fique ligado!',
      'In development': 'Em desenvolvimento',
    },
    es: {
      'Coming soon': 'Próximamente',
      'Something new is on the way': 'Algo nuevo está en camino',
      'We are preparing something new for you. Stay tuned!': 'Estamos preparando algo nuevo para ti. ¡Mantente atento!',
      'In development': 'En desarrollo',
    },
  },
  props: {
    logo: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "#2C00F5",
    },
  },
};
</script>

<template>
  <div class="coming-soon" :style="{ '--brand': color }">
    <span class="coming-soon-glow coming-soon-glow-1"></span>
    <span class="coming-soon-glow coming-soon-glow-2"></span>
    <div class="coming-soon-content">
      <img v-if="logo" :src="logo" :alt="name" class="coming-soon-logo" />
      <span class="coming-soon-badge">
        <span class="coming-soon-dot"></span>
        {{ t('In development') }}
      </span>
      <h1 class="coming-soon-title">{{ t('Coming soon') }}</h1>
      <p class="coming-soon-subtitle">{{ t('Something new is on the way') }}</p>
      <p class="coming-soon-text">{{ t('We are preparing something new for you. Stay tuned!') }}</p>
      <div class="coming-soon-bar"><span></span></div>
    </div>
  </div>
</template>

<style scoped>
.coming-soon {
  position: relative;
  overflow: hidden;
  max-width: 640px;
  margin: 2rem auto;
  padding: 3rem 2rem;
  border-radius: 24px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 20px 50px -20px rgba(0, 0, 0, 0.18);
  text-align: center;
}

.coming-soon-glow {
  position: absolute;
  border-radius: 50%;
  background: var(--brand);
  filter: blur(70px);
  opacity: 0.1;
  pointer-events: none;
}

.coming-soon-glow-1 {
  width: 260px;
  height: 260px;
  top: -110px;
  right: -80px;
}

.coming-soon-glow-2 {
  width: 220px;
  height: 220px;
  bottom: -120px;
  left: -70px;
}

.coming-soon-content {
  position: relative;
}

.coming-soon-logo {
  height: 36px;
  max-width: 100%;
  display: block;
  margin: 0 auto 1.75rem;
}

.coming-soon-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.35rem 0.9rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--brand);
  background: color-mix(in srgb, var(--brand) 10%, transparent);
}

.coming-soon-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--brand);
  animation: coming-soon-pulse 1.6s ease-in-out infinite;
}

.coming-soon-title {
  margin: 1.25rem 0 0.5rem;
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--brand);
}

.coming-soon-subtitle {
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: #222;
}

.coming-soon-text {
  margin-bottom: 2rem;
  color: #6c757d;
}

.coming-soon-bar {
  position: relative;
  overflow: hidden;
  height: 6px;
  max-width: 260px;
  margin: 0 auto;
  border-radius: 999px;
  background: color-mix(in srgb, var(--brand) 12%, transparent);
}

.coming-soon-bar span {
  position: absolute;
  top: 0;
  left: -40%;
  width: 40%;
  height: 100%;
  border-radius: 999px;
  background: var(--brand);
  animation: coming-soon-slide 1.8s ease-in-out infinite;
}

@keyframes coming-soon-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.4; transform: scale(0.8); }
}

@keyframes coming-soon-slide {
  0% { left: -40%; }
  100% { left: 100%; }
}

@media (prefers-reduced-motion: reduce) {
  .coming-soon-dot,
  .coming-soon-bar span {
    animation: none;
  }
}

@media (min-width: 992px) {
  .coming-soon-title {
    font-size: 2rem;
  }
}

@media (max-width: 576px) {
  .coming-soon {
    padding: 2.25rem 1.25rem;
  }
}
</style>
